// extracted by mini-css-extract-plugin
export default {"container":"container-oKzas","h1":"h1-J+kQo","h2":"h2-Q-ODN"};